import { TrendValue } from "./components/TrendValue";
import { formatCompactCurrency, formatCurrency, formatDecimal, formatInteger, formatPercent } from "./formatters";

export function renderHeaderLabel(label) {
  const match = /^Prior Q\s+(.+)$/i.exec(label);
  if (!match) return label;
  return (
    <span className="flex flex-col items-end leading-tight">
      <span className="whitespace-nowrap">Prior Q</span>
      <span className="whitespace-nowrap">{match[1]}</span>
    </span>
  );
}

// "By Days Late" and "By Reason" QoQ Change track worsening outcomes (more
// late deliveries / more of a given failure reason), so an increase is bad
// (red) and a decrease is good (green) — the inverse of most breakdown
// tables, where an increase in DIFOT % is good. The "On Time" bucket is
// excluded since it's expected to hold near 0% and isn't meaningful to flag.
const INVERSE_QOQ_TABLE_KEYS = new Set(["byDaysLate", "byReason"]);
const isOnTimeBucket = (label) => typeof label === "string" && /on time/i.test(label);

export function renderTableCell(key, value, context = {}) {
  const { tableKey, dimensionValue } = context;
  if (key === "qoqChange" || key === "consignmentsQoqPct") {
    if (INVERSE_QOQ_TABLE_KEYS.has(tableKey)) {
      if (tableKey === "byDaysLate" && isOnTimeBucket(dimensionValue)) {
        return <TrendValue value={value} neutral />;
      }
      return <TrendValue value={value} inverse />;
    }
    return <TrendValue value={value} />;
  }
  if (key === "spendQoqPct") {
    return <TrendValue value={value} />;
  }
  if (key === "difotPct" || key === "priorQDifotPct" || key === "dlPct" || key === "podPct") {
    return formatPercent(value);
  }
  if (key === "spend" || key === "spendYtd" || key === "priorQSpend") {
    return <span className="font-black">{formatCurrency(value)}</span>;
  }
  if (key === "spendPerKg") {
    return formatCompactCurrency(value);
  }
  if (key === "itemsPerCon" || key === "kgPerCon") {
    return formatDecimal(value);
  }
  if (key === "weightKg") {
    return formatInteger(value);
  }
  return formatInteger(value);
}

export function renderStatusCell(key, value) {
  if (key === "qoqChange" || key === "consignmentsQoqPct") {
    return <TrendValue value={value} />;
  }
  if (key === "dlPct" || key === "podPct") {
    return formatPercent(value);
  }
  if (key === "spend") {
    return <span className="font-black">{formatCurrency(value)}</span>;
  }
  return formatInteger(value);
}

export function renderPeriodCell(key, value) {
  if (key === "qoqChange" || key === "spendQoqPct" || key === "podQoqChange" || key === "consignmentsQoqPct") {
    return <TrendValue value={value} />;
  }
  if (key === "dlQoqChange") {
    return <TrendValue value={value} inverse />;
  }
  if (
    key === "difotPct" ||
    key === "dlPct" ||
    key === "podPct" ||
    key === "priorQDifotPct" ||
    key === "priorQDlPct" ||
    key === "priorQPodPct"
  ) {
    return formatPercent(value);
  }
  if (key === "spend" || key === "priorQSpend" || key === "spendYtd") {
    return <span className="font-black">{formatCurrency(value)}</span>;
  }
  if (key === "spendPerKg") {
    return formatCompactCurrency(value);
  }
  if (key === "itemsPerCon" || key === "kgPerCon") {
    return formatDecimal(value);
  }
  if (key === "weightKg") {
    return formatInteger(value);
  }
  return formatInteger(value);
}

export function renderSurchargeCell(key, value) {
  if (key === "consignmentsQoqPct" || key === "spendQoqPct") {
    return <TrendValue value={value} />;
  }
  if (key === "spend" || key === "priorQSpend") {
    return <span className="font-black">{formatCurrency(value)}</span>;
  }
  return formatInteger(value);
}
